import React from "react";
import { useTranslation } from "react-i18next";
import StyledText from "../../util/StyledText";

const QcmMarkerForm = ({
  question,
  answersArray,
  correctAnswers,
  successMessage,
  errorMessage,
  handleQuestionChange,
  handleAnswerChange,
  handleCorrectAnswerChange,
  handleSuccessMessageChange,
  handleErrorMessageChange,
  handleAddAnswer,
  noCorrectAnswer,
  neutralMessage,
  handleNeutralMessageChange,
  handleNoCorrectAnswerToggle,
  index,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <label className="mt-4">{t("questionQuiz")} * </label>
      <StyledText
        markerText={question}
        setMarkerText={(value) => handleQuestionChange(value, index)}
        index={index}
      />

      {answersArray &&
        answersArray.length > 0 &&
        answersArray.map((answer, index) => (
          <div key={index}>
            <label className="mt-4">
              {t("qcmAnswersChoices")} {index + 1} *
            </label>
            <StyledText
              markerText={answer}
              setMarkerText={(value) => handleAnswerChange(value, index)}
              index={index}
            />
            <input
              type="checkbox"
              checked={correctAnswers
                .map((x) => parseInt(x, 10))
                .includes(index)}
              onChange={(event) => handleCorrectAnswerChange(event, index)}
              disabled={noCorrectAnswer}
            />
            <label>{t("correctAnswers")}</label>
          </div>
        ))}
      <div className="mt-3">
        <input
          type="checkbox"
          checked={noCorrectAnswer}
          onChange={() => handleNoCorrectAnswerToggle(index)}
        />
        <label className="ms-2">{t("noCorrectAnswer")}</label>
      </div>

      {answersArray.length < 13 && (
        <button
          className="buttonModifMarker mt-2  p-2 "
          onClick={handleAddAnswer}
        >
          {t("addOption")}
        </button>
      )}

      {noCorrectAnswer ? (
        <>
          <label className="mt-4">{t("neutralMessage")}</label>
          <StyledText
            key={`neutral-${index}`}
            markerText={neutralMessage}
            setMarkerText={(value) => handleNeutralMessageChange(value, index)}
            index={index}
          />
        </>
      ) : (
        <>
          <label className="mt-4">{t("successMessageQuiz")}</label>
          <StyledText
            key={`success-${index}`}
            markerText={successMessage}
            setMarkerText={(value) => handleSuccessMessageChange(value, index)}
            index={index}
          />

          <label className="mt-4">{t("errorMessageQuiz")}</label>
          <StyledText
            key={`error-${index}`}
            markerText={errorMessage}
            setMarkerText={(value) => handleErrorMessageChange(value, index)}
            index={index}
          />
        </>
      )}
    </>
  );
};

export default QcmMarkerForm;
